import { useEffect, useRef, useState } from 'react';

const diferenciais = [
  {
    icon: 'ri-shield-star-line',
    gradient: 'from-vermelho to-red-400',
    title: 'Ambiente Seguro',
    desc: 'Câmeras de monitoramento, portão eletrônico, área de recreação cercada e equipe treinada para garantir total segurança das crianças.',
    highlight: 'Segurança 24h',
  },
  {
    icon: 'ri-heart-add-line',
    gradient: 'from-azul-claro to-cyan-400',
    title: 'Atendimento Humanizado',
    desc: 'Cada criança é tratada de forma individual e afetiva. Nossas professoras conhecem o nome, as necessidades e a personalidade de cada aluno.',
    highlight: 'Foco no indivíduo',
  },
  {
    icon: 'ri-football-line',
    gradient: 'from-azul-medio to-blue-400',
    title: 'Atividades Recreativas',
    desc: 'Recreação orientada, psicomotricidade, dança, música e artes integram a rotina escolar, estimulando a criatividade e o movimento.',
    highlight: 'Corpo e mente',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    gradient: 'from-azul-escuro to-blue-700',
    title: 'Acompanhamento do Desenvolvimento',
    desc: 'Relatórios periódicos e reuniões com famílias para garantir transparência e parceria no acompanhamento do desenvolvimento de cada criança.',
    highlight: 'Família parceira',
  },
  {
    icon: 'ri-seedling-line',
    gradient: 'from-vermelho to-orange-400',
    title: 'Ensino com Valores',
    desc: 'Princípios cristãos integrados ao currículo formam crianças com caráter, empatia, honestidade e amor ao próximo.',
    highlight: 'Formação integral',
  },
  {
    icon: 'ri-restaurant-line',
    gradient: 'from-azul-claro to-teal-400',
    title: 'Alimentação e Cuidado',
    desc: 'Refeições balanceadas, momento de descanso e higiene fazem parte da nossa rotina, promovendo saúde e bem-estar no contra turno.',
    highlight: 'Saúde e bem-estar',
  },
];

const stats = [
  { value: '10+', label: 'Anos de experiência' },
  { value: '200+', label: 'Famílias atendidas' },
  { value: '99%', label: 'Satisfação dos pais' },
  { value: '5', label: 'Turmas disponíveis' },
];

export default function Diferenciais() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="diferenciais" className="py-24 bg-cinza" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block bg-azul-claro/20 text-azul-escuro font-body font-700 text-sm px-4 py-1.5 rounded-full mb-4">
            Por que nos escolher?
          </span>
          <h4 id="diferenciais-section">
            <a className="font-heading text-[#0D0D0D] text-3xl lg:text-4xl block">
              Nossos <span className="text-vermelho">diferenciais</span>
            </a>
          </h4>
          <p className="font-body text-gray-500 text-base mt-4 max-w-xl mx-auto">
            Mais do que uma escola, somos uma extensão do lar. Conheça o que torna a Turminha da Alegria especial.
          </p>
        </div>

        {/* Stats bar */}
        <div
          className={`grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {stats.map((stat) => (
            <div key={stat.label} className="bg-white rounded-2xl p-6 text-center">
              <p className="font-heading text-azul-escuro text-4xl">{stat.value}</p>
              <p className="font-body text-gray-500 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {diferenciais.map((item, i) => (
            <div
              key={item.title}
              className={`group bg-white rounded-3xl p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-300 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 100 + 200}ms` }}
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${item.gradient} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-white text-2xl`} />
              </div>
              <span className="inline-block bg-cinza font-body text-gray-400 text-xs px-3 py-1 rounded-full mb-3">
                {item.highlight}
              </span>
              <h5 className="font-heading text-[#0D0D0D] text-xl mb-3">{item.title}</h5>
              <p className="font-body text-gray-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
